import React from "react";

import pose from "../assets/Home/pose.png";
import { Link } from 'react-router-dom';

import logo from "../assets/Home/logo.png";

import "./Footer.css";

const Footer = () => {

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' }); // or 'auto'
  };
  
  return (
    <footer className="footer">
      <div className="container">
        <img src={pose} className="pose-img" />
        <div className="content-container">

          <div className="company-motto">
            <img src={logo} className="company-logo" />
            <p className="company-motto-description">
              Enigneering excellence and construction <br />
              expertise for over two decades.Building <br />
              tomorrow's infrastructure today.
            </p>
          </div>

          <div className="links-container">
            <h1 className="quick-links-heading">Quick Links</h1>
            {/* <a className="fotter-link m-1">About us</a>
            <a className="fotter-link m-1">Services</a>
            <a className="fotter-link m-1">Projects</a>
            <a className="fotter-link m-1">company Culture</a>
            <a className="fotter-link m-1">Contact</a> */}
            <Link to="/about" onClick={scrollToTop} className="fotter-link m-1">About Us</Link>
            <Link to="/services" onClick={scrollToTop} className="fotter-link m-1">Services</Link>
            <Link to="/projects" onClick={scrollToTop} className="fotter-link m-1">Projects</Link>
            <Link to="/companyCulture" onClick={scrollToTop} className="fotter-link m-1">Company Culture</Link>
            <Link to="/contact"  onClick={scrollToTop} className="fotter-link m-1">Contact</Link>
          </div>

          <div className="contact-information">
            <h1 className="quick-links-heading">contact information</h1>
            <div>
              <p className="m-1">Riyadh Headquarters</p>
              <p className="fotter-link m-1">King Fahd Road, Riyadh 12345</p>
              <p className="fotter-link">+966 11 123 4567</p>
            </div>
            <div>
              <p className="m-1">Khobar Branch</p>
              <p className="fotter-link m-1">Prince Faisal Bin Fahd Road</p>
              <p className="fotter-link">+966 13 234 5678</p>
            </div>
            <a className="fotter-link">info@tauc-services.com</a>
          </div>
        </div>
        
        <img src={pose} className="pose-img" />
      </div>
      <hr />
      <div className="d-flex justify-content-between px-3">
        <p className="copy-rights">
          ISO 9001 | ISO 14001 | ISO 45001 Certified
        </p>
        <p className="copy-rights">
          © 2025 TAUC Engineering & Construction. All rights reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
